import { render } from "./HeroSettingUserManual.vue?vue&type=template&id=45a0e8cb&scoped=true"
import script from "./HeroSettingUserManual.vue?vue&type=script&lang=js"
export * from "./HeroSettingUserManual.vue?vue&type=script&lang=js"

import "./HeroSettingUserManual.vue?vue&type=style&index=0&id=45a0e8cb&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a0e8cb"]])

export default __exports__